import { Directive, ElementRef, EventEmitter, Input, Output, HostBinding, NgModule } from '@angular/core';
import { fromEvent, timer } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
class DragDropListDirective {
    /**
     * @param {?} elementRef
     */
    constructor(elementRef) {
        this.elementRef = elementRef;
        this._trigger = this.elementRef.nativeElement;
        this.attr = '';
        this.dragDropListChange = new EventEmitter();
        this.duration = 500;
        this.mouseMove = (/**
         * @param {?} $event
         * @return {?}
         */
        ($event) => {
            const { dragElement, dropElement, targetElementInitialBoundingBox } = this.data;
            const { width: targetWidth, height: targetHeight, left: targetLeft, top: targetTop } = targetElementInitialBoundingBox;
            const { left, top, width, height } = dragElement.getBoundingClientRect();
            if (dropElement) {
                dropElement.style.filter = null;
            }
            dragElement.style.pointerEvents = 'none';
            /** @type {?} */
            const elements = document.elementsFromPoint(left + (width / 2), top + (height / 2));
            /** @type {?} */
            const newDropElement = (/** @type {?} */ (elements.find((/**
             * @param {?} element
             * @return {?}
             */
            (element) => this.brothers.includes(element)))));
            if (newDropElement) {
                dragElement.style.pointerEvents = null;
                newDropElement.style.filter = 'blur(2px)';
            }
            this.data.dropElement = newDropElement;
            dragElement.style.transition = null;
            dragElement.style.zIndex = '200';
            /** @type {?} */
            const translateX = $event.clientX - targetLeft - (targetWidth / 2);
            /** @type {?} */
            const translateY = $event.clientY - targetTop - (targetHeight / 2);
            dragElement.style.transform = `translate(${translateX}px, ${translateY}px)`;
        });
        this.mouseUp = (/**
         * @return {?}
         */
        () => {
            document.removeEventListener('mousemove', this.mouseMove);
            document.removeEventListener('mouseup', this.mouseUp);
            const { dragElement, dropElement, dragElementInitialBoundingBox } = this.data;
            const { left: initialLeft, top: initialTop, width: dragWidth, height: dragHeight } = dragElementInitialBoundingBox;
            document.body.style.userSelect = null;
            dragElement.style.transition = `transform ${this.duration}ms`;
            timer(this.duration).pipe(tap((/**
             * @return {?}
             */
            () => {
                dragElement.style.pointerEvents = null;
                dragElement.style.transition = null;
                dragElement.style.transform = null;
                dragElement.style.zIndex = null;
                if (dropElement) {
                    dropElement.style.transform = null;
                    dropElement.style.zIndex = null;
                    dropElement.style.transition = null;
                    /** @type {?} */
                    const cloneList = [...this.dragDropList];
                    /** @type {?} */
                    const dragIndex = this.brothers.indexOf(dragElement);
                    /** @type {?} */
                    const dropIndex = this.brothers.indexOf(dropElement);
                    cloneList[dragIndex] = this.dragDropList[dropIndex];
                    cloneList[dropIndex] = this.dragDropList[dragIndex];
                    this.dragDropListChange.emit(cloneList);
                }
            }))).subscribe();
            if (dropElement) {
                const { left: dropLeft, top: dropTop } = dropElement.getBoundingClientRect();
                dropElement.style.filter = null;
                dropElement.style.transition = `transform ${this.duration}ms`;
                dropElement.style.transform = `translate(${initialLeft - dropLeft}px, ${initialTop - dropTop}px)`;
                dragElement.style.transform = `translate(${dropLeft - initialLeft}px, ${dropTop - initialTop}px)`;
                dropElement.style.zIndex = '199';
                dropElement.classList.remove('droppable');
            }
            else {
                dragElement.style.transform = `translate(0, 0)`;
            }
            this.data = null;
        });
    }
    /**
     * @param {?} value
     * @return {?}
     */
    set trigger(value) {
        if (this.elementRef.nativeElement.hasChildNodes(value)) {
            this._trigger = value;
        }
        else {
            console.error('Input "dragItem" must be a valid child of:', this.elementRef.nativeElement);
            throw new Error();
        }
    }
    /**
     * @return {?}
     */
    get trigger() {
        return this._trigger;
    }
    /**
     * @return {?}
     */
    get brothers() {
        return (/** @type {?} */ (Array
            .from(this.elementRef.nativeElement.parentElement.children)
            .filter((/**
         * @param {?} elem
         * @return {?}
         */
        (elem) => {
            return Array.from(elem.attributes)
                .map((/**
             * @param {?} attr
             * @return {?}
             */
            (attr) => attr.nodeName))
                .some((/**
             * @param {?} name
             * @return {?}
             */
            (name) => name.includes('dragdroplist')));
        }))));
    }
    /**
     * @return {?}
     */
    ngOnInit() {
        this.mousedownSubscription = fromEvent(this.trigger, 'mousedown').pipe(tap((/**
         * @return {?}
         */
        () => {
            /** @type {?} */
            const dragElement = this.elementRef.nativeElement;
            document.body.style.userSelect = 'none';
            /** @type {?} */
            const dragElementInitialBoundingBox = dragElement.getBoundingClientRect();
            /** @type {?} */
            const targetElementInitialBoundingBox = this.trigger.getBoundingClientRect();
            this.data = { dragElement, dragElementInitialBoundingBox, targetElementInitialBoundingBox };
            document.addEventListener('mousemove', this.mouseMove);
            document.addEventListener('mouseup', this.mouseUp);
        }))).subscribe();
    }
    /**
     * @return {?}
     */
    ngOnDestroy() {
        this.mousedownSubscription.unsubscribe();
    }
}
DragDropListDirective.ɵfac = function DragDropListDirective_Factory(t) { return new (t || DragDropListDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DragDropListDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DragDropListDirective, selectors: [["", "dragDropList", ""]], hostVars: 1, hostBindings: function DragDropListDirective_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵattribute("dragdroplist", ctx.attr);
    } }, inputs: { duration: "duration", trigger: "trigger", dragDropList: "dragDropList" }, outputs: { dragDropListChange: "dragDropListChange" } });
/** @nocollapse */
DragDropListDirective.ctorParameters = () => [
    { type: ElementRef }
];
DragDropListDirective.propDecorators = {
    attr: [{ type: HostBinding, args: [`attr.dragdroplist`,] }],
    dragDropList: [{ type: Input }],
    trigger: [{ type: Input }],
    dragDropListChange: [{ type: Output }],
    duration: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DragDropListDirective, [{
        type: Directive,
        args: [{
                selector: '[dragDropList]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { attr: [{
            type: HostBinding,
            args: [`attr.dragdroplist`]
        }], dragDropListChange: [{
            type: Output
        }], duration: [{
            type: Input
        }], trigger: [{
            type: Input
        }], dragDropList: [{
            type: Input
        }] }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
class DragDropListModule {
}
DragDropListModule.ɵfac = function DragDropListModule_Factory(t) { return new (t || DragDropListModule)(); };
DragDropListModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: DragDropListModule });
DragDropListModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[CommonModule]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DragDropListModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [DragDropListDirective],
                exports: [DragDropListDirective]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(DragDropListModule, { declarations: function () { return [DragDropListDirective]; }, imports: function () { return [CommonModule]; }, exports: function () { return [DragDropListDirective]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { DragDropListModule, DragDropListDirective };

